<div class="multi-select">
  <div class="multi-select__control" (click)="toggleDropdown()">
    <span *ngIf="_value.length === 0">{{ placeholder }}</span>
    <span *ngIf="_value.length > 0">
      {{ displayValue }}
    </span>
    <i [ngClass]="isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
  </div>

  <div class="multi-select__dropdown" *ngIf="isOpen">
    <ul>
      <li *ngFor="let item of list" (click)="selectItem(item)">
        <input type="checkbox" [checked]="isSelected(item)" />
        {{ listDisplay ? item[listDisplay] : item }}
      </li>
    </ul>
  </div>
</div>
